import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';

const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('./split-plane/split-plane.module').then(
        (m) => m.SplitPlanePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'updateUserProfile',
    loadChildren: () =>
      import('./update-user-profile/update-user-profile.module').then(
        (m) => m.UpdateUserProfileModule
      ),
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
  {
    path: 'app/profile',
    loadChildren: () =>
      import('./profile-section/profile-section.module').then(
        (m) => m.ProfileSectionPageModule
      ),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 're-auth-methods',
    loadChildren: () =>
      import('./re-auth-methods/re-auth-methods.module').then(
        (m) => m.ReAuthMethodsModule
      ),
  },
  {
    path: 'playscreen',
    loadChildren: () =>
      import('./playscreen/playscreen.module').then(
        (m) => m.PlayscreenPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile-section',
    loadChildren: () =>
      import('./profile-section/profile-section.module').then(
        (m) => m.ProfileSectionPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
